/* EclatDent — Compose ton pack : pack builder visuel + barre promo « hype train » */
(() => {
  const root = document.querySelector('[data-ed-compose]');
  if (!root || root.__edcpInit) return;
  root.__edcpInit = true;

  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  let tiers = [];
  try { tiers = JSON.parse(root.dataset.tiers || '[]'); } catch (e) { tiers = []; }
  // dédoublonne par quantité, garde le meilleur %, trie
  const seen = {};
  // 02/11 : 3e élément = remise fixe par tube en centimes (remises Shopify en montant), sinon pourcentage
  const offs = {};
  tiers.forEach(([q, p, o]) => { if (q > 0 && p > 0 && (!seen[q] || p > seen[q])) { seen[q] = p; offs[q] = Number(o) || 0; } });
  tiers = Object.keys(seen).map((q) => [Number(q), seen[q], offs[q]]).sort((a, b) => a[0] - b[0]);
  const minTubes = Number(root.dataset.min) || 1;
  const freeShipMin = Number(root.dataset.freeShipMin) || 2;
  const maxQ = tiers.length ? tiers[tiers.length - 1][0] : minTubes;

  const T = {
    hypeStart: root.dataset.tHypeStart,
    hypeMax: root.dataset.tHypeMax,
    unlocked: root.dataset.tUnlocked,
    empty: root.dataset.tEmpty,
    perTube: root.dataset.tPertube,
    remove: root.dataset.tRemove,
    selected: root.dataset.tSelected,
    subtotal: root.dataset.tSubtotal,
    discount: root.dataset.tDiscount,
    total: root.dataset.tTotal,
    save: root.dataset.tSave,
    addmoreA: root.dataset.tAddmoreA,
    addmoreB: root.dataset.tAddmoreB,
    addmoreBPlural: root.dataset.tAddmoreBPlural,
    addedBadge: root.dataset.tAddedBadge,
    ctaPrice: root.dataset.tCtaPrice,
    addedToast: root.dataset.tAddedToast,
    fail: root.dataset.tFail,
  };

  const money = (cents) => '€' + (cents / 100).toFixed(2).replace('.', ',');

  // — État —
  const cards = [...root.querySelectorAll('[data-ed-tube]')];
  const state = new Map();
  cards.forEach((card) => {
    state.set(card.dataset.variant, {
      qty: 0,
      price: Number(card.dataset.price) || 0,
      title: card.dataset.title || '',
      png: card.dataset.png || '',
      card,
    });
  });

  const els = {
    hype: root.querySelector('[data-ed-hype]'),
    hypeLabel: root.querySelector('[data-ed-hype-label]'),
    hypeFill: root.querySelector('[data-ed-hype-fill]'),
    hypeStations: root.querySelector('[data-ed-hype-stations]'),
    empty: root.querySelector('[data-ed-empty]'),
    lines: root.querySelector('[data-ed-lines]'),
    full: root.querySelector('[data-ed-full]'),
    pertube: root.querySelector('[data-ed-pertube]'),
    subtotal: root.querySelector('[data-ed-subtotal]'),
    discountRow: root.querySelector('[data-ed-discount-row]'),
    discount: root.querySelector('[data-ed-discount]'),
    total: root.querySelector('[data-ed-total]'),
    save: root.querySelector('[data-ed-save]'),
    freeship: root.querySelector('[data-ed-freeship]'),
    nudge: root.querySelector('[data-ed-nudge]'),
    pack: root.querySelector('[data-ed-basket]'),
    dock: root.querySelector('[data-ed-dock]'),
    dockCount: root.querySelector('[data-ed-dock-count]'),
    dockTotal: root.querySelector('[data-ed-dock-total]'),
    dockItems: root.querySelector('[data-ed-dock-items]'),
  };
  const ctaButtons = [...root.querySelectorAll('[data-ed-cta]')];

  // — Popup d'ajustement d'un tube du pack —
  const modal = root.querySelector('[data-ed-modal]');
  const modalEls = modal ? {
    img: modal.querySelector('[data-ed-modal-img]'),
    name: modal.querySelector('[data-ed-modal-name]'),
    price: modal.querySelector('[data-ed-modal-price]'),
    qty: modal.querySelector('[data-ed-modal-qtyval]'),
    card: modal.querySelector('[data-ed-modal-card]'),
  } : null;
  let modalId = null;
  const dialogOk = modal && typeof modal.showModal === 'function';

  function updateModal() {
    const it = state.get(modalId);
    if (!it || !modalEls) return;
    modalEls.img.src = it.png; modalEls.img.alt = it.title;
    modalEls.name.textContent = it.title;
    modalEls.qty.textContent = it.qty;
    modalEls.price.textContent = money(it.qty * it.price);
    if (modalEls.card) modalEls.card.style.setProperty('--glow', it.card.style.getPropertyValue('--glow') || '#4A90E2');
  }
  function openModal(id) { modalId = id; updateModal(); if (dialogOk) modal.showModal(); }
  function closeModal() { if (dialogOk && modal.open) modal.close(); }
  if (modal) {
    modal.querySelector('[data-ed-modal-dec]').addEventListener('click', () => {
      const it = state.get(modalId); if (!it) return;
      it.qty = Math.max(0, it.qty - 1); render();
      if (it.qty === 0) closeModal(); else updateModal();
    });
    modal.querySelector('[data-ed-modal-inc]').addEventListener('click', () => {
      const it = state.get(modalId); if (!it) return;
      it.qty = Math.min(20, it.qty + 1); render(); updateModal();
    });
    modal.querySelector('[data-ed-modal-remove]').addEventListener('click', () => {
      const it = state.get(modalId); if (it) it.qty = 0; render(); closeModal();
    });
    modal.querySelectorAll('[data-ed-modal-close]').forEach((b) => b.addEventListener('click', closeModal));
    modal.addEventListener('click', (e) => { if (e.target === modal) closeModal(); });
  }

  // — Animation « fly to pack » depuis une carte de la grille —
  function flyToPack(card) {
    if (reduced || !els.pack) return;
    const img = card.querySelector('.edcp-card-media img');
    if (!img) return;
    const s = img.getBoundingClientRect();
    const t = els.pack.getBoundingClientRect();
    const clone = img.cloneNode(true);
    clone.style.cssText = 'position:fixed;left:' + s.left + 'px;top:' + s.top + 'px;width:' + s.width + 'px;height:' + s.height +
      'px;object-fit:contain;z-index:9999;pointer-events:none;transition:transform .6s cubic-bezier(.5,-0.15,.3,1),opacity .6s ease-in;';
    document.body.appendChild(clone);
    const dx = (t.left + t.width / 2) - (s.left + s.width / 2);
    const dy = (t.top + Math.min(t.height / 2, 80)) - (s.top + s.height / 2);
    requestAnimationFrame(() => { clone.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(.28)'; clone.style.opacity = '0.15'; });
    setTimeout(() => clone.remove(), 640);
    els.pack.classList.remove('is-pulse'); void els.pack.offsetWidth; els.pack.classList.add('is-pulse');
  }

  // — Construit les stations de la barre hype —
  const stationEls = [];
  tiers.forEach(([q, p], i) => {
    const st = document.createElement('div');
    st.className = 'edcp-hype-station';
    st.style.left = Math.min(100, (q / maxQ) * 100) + '%';
    st.innerHTML = '<span class="edcp-coin"><b>' + p + '%</b></span><span class="edcp-hype-q">' + q + '</span>';
    els.hypeStations.appendChild(st);
    stationEls.push({ el: st, q, p });
  });

  let offTube = 0;
  function tierFor(qty) {
    let pct = 0, next = null;
    offTube = 0;
    for (const [q, p, o] of tiers) {
      if (qty >= q) { pct = p; offTube = o || 0; }
      else if (next === null) next = [q, p];
    }
    return { pct, next };
  }

  let prevPct = 0;
  let prevTotal = -1;
  function renderHype(totalQty, pct, next) {
    const fillPct = Math.min(100, (totalQty / maxQ) * 100);
    els.hypeFill.style.width = fillPct + '%';
    els.hype.classList.toggle('is-live', totalQty > 0);
    stationEls.forEach((s) => s.el.classList.toggle('is-on', totalQty >= s.q));

    if (pct > prevPct && totalQty > 0) {
      // déblocage : flash + label temporaire
      els.hype.classList.remove('is-unlock');
      void els.hype.offsetWidth;
      els.hype.classList.add('is-unlock');
      els.hypeLabel.innerHTML = '<strong>−' + pct + '% ' + T.unlocked + '</strong>';
    } else if (next) {
      const gap = next[0] - totalQty;
      const w = gap > 1 ? T.addmoreBPlural : T.addmoreB;
      els.hypeLabel.innerHTML = T.addmoreA + ' <strong>' + gap + ' ' + w + ' −' + next[1] + '%</strong>';
    } else if (pct > 0) {
      els.hypeLabel.innerHTML = '<strong>' + T.hypeMax + ' 🎉</strong>';
    } else {
      els.hypeLabel.textContent = T.hypeStart;
    }
    prevPct = pct;
  }

  function render() {
    let totalQty = 0, subtotal = 0;
    state.forEach((it) => { totalQty += it.qty; subtotal += it.qty * it.price; });
    const { pct, next } = tierFor(totalQty);
    // Arrondi identique au checkout Shopify : remise tronquée par unité (au centime inférieur), puis × qty
    let discount = 0;
    const offFor = (price) => (offTube ? Math.min(offTube, price) : Math.floor(price * pct / 100));
    state.forEach((it) => { if (it.qty > 0) discount += offFor(it.price) * it.qty; });
    const finalTotal = subtotal - discount;

    renderHype(totalQty, pct, next);

    // Cartes : badge quantité + état actif
    state.forEach((it) => {
      const badge = it.card.querySelector('[data-ed-badge]');
      if (badge) { badge.textContent = it.qty; badge.hidden = it.qty === 0; }
      it.card.classList.toggle('is-active', it.qty > 0);
    });

    const enough = totalQty >= minTubes;
    els.empty.hidden = totalQty > 0;
    els.lines.hidden = totalQty === 0;
    els.full.hidden = !enough;
    els.dock.hidden = !enough;

    // Pack visuel : les tubes assemblés (PNG debout, badge quantité, croix)
    els.lines.innerHTML = '';
    state.forEach((it, id) => {
      if (it.qty === 0) return;
      const item = document.createElement('button');
      item.type = 'button';
      item.className = 'edcp-pack-item';
      item.setAttribute('aria-label', it.title + ' × ' + it.qty);
      item.style.setProperty('--glow', it.card.style.getPropertyValue('--glow') || '#4A90E2');
      item.innerHTML =
        '<span class="edcp-pack-edit" aria-hidden="true">✎</span>' +
        '<div class="edcp-pack-tube"><img src="' + it.png + '" alt="" width="60" height="72" loading="lazy">' +
        (it.qty > 1 ? '<span class="edcp-pack-qty">×' + it.qty + '</span>' : '') + '</div>' +
        '<span class="edcp-pack-name">' + it.title + '</span>';
      item.addEventListener('click', () => openModal(id));
      els.lines.appendChild(item);
    });

    if (!enough) return;

    // Prix / tube effectif
    els.pertube.hidden = false;
    els.pertube.textContent = '≈ ' + money(Math.round(finalTotal / totalQty)) + ' ' + T.perTube;

    els.subtotal.textContent = money(subtotal);
    if (discount > 0) {
      els.discountRow.hidden = false;
      els.discount.textContent = '−' + money(discount) + ' (−' + pct + '%)';
      els.save.hidden = false;
      els.save.textContent = '✨ ' + T.save + ' ' + money(discount);
    } else {
      els.discountRow.hidden = true;
      els.save.hidden = true;
    }
    els.total.textContent = money(finalTotal);
    if (finalTotal !== prevTotal) {
      prevTotal = finalTotal;
      if (!reduced) { els.total.classList.remove('is-pop'); void els.total.offsetWidth; els.total.classList.add('is-pop'); }
    }
    // 02/11/2026 : gratuité au montant (France dès 20 €), plus au nombre de tubes
    const freeShipCents = Number(root.dataset.freeShipCents) || 0;
    els.freeship.hidden = freeShipCents ? finalTotal < freeShipCents : totalQty < freeShipMin;

    if (next) {
      const gap = next[0] - totalQty;
      const w = gap > 1 ? T.addmoreBPlural : T.addmoreB;
      els.nudge.hidden = false;
      els.nudge.innerHTML = '🔥 ' + T.addmoreA + ' <strong>' + gap + ' ' + w + ' −' + next[1] + '%</strong>';
    } else {
      els.nudge.hidden = true;
    }

    const priceStr = money(finalTotal);
    const ctaLabel = T.ctaPrice + priceStr;
    ctaButtons.forEach((b) => { if (!b.classList.contains('is-busy')) b.textContent = ctaLabel; });
    els.dockCount.textContent = totalQty;
    els.dockTotal.textContent = priceStr;

    // Détail par dentifrice dans la barre du bas : miniature · ×qté · prix (remisé)
    if (els.dockItems) {
      els.dockItems.innerHTML = '';
      state.forEach((it) => {
        if (it.qty === 0) return;
        const line = it.qty * (it.price - (offTube ? Math.min(offTube, it.price) : Math.floor(it.price * pct / 100)));
        const chip = document.createElement('span');
        chip.className = 'edcp-dock-chip';
        chip.style.setProperty('--glow', it.card.style.getPropertyValue('--glow') || '#4A90E2');
        chip.innerHTML =
          '<img src="' + it.png + '" alt="" width="24" height="29" loading="lazy">' +
          '<b>×' + it.qty + '</b>' +
          '<span>' + money(line) + '</span>';
        els.dockItems.appendChild(chip);
      });
    }
  }

  // — Clic sur un tube = +1 (avec petit rebond) —
  cards.forEach((card) => {
    const it = state.get(card.dataset.variant);
    card.querySelector('[data-ed-add]').addEventListener('click', () => {
      it.qty = Math.min(20, it.qty + 1);
      if (!reduced) {
        card.classList.remove('bump'); void card.offsetWidth; card.classList.add('bump');
        flyToPack(card);
      }
      render();
    });
  });

  // — Achat direct : on vide le panier, on ajoute UNIQUEMENT le pack composé,
  //   puis on file droit au paiement. La remise auto s'applique au checkout. —
  function buyPack() {
    const items = [];
    state.forEach((it, id) => { if (it.qty > 0) items.push({ id: Number(id), quantity: it.qty }); });
    if (!items.length) return;
    ctaButtons.forEach((b) => { b.setAttribute('disabled', 'disabled'); b.classList.add('is-busy'); });
    fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
      .then(() => fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      }))
      .then((r) => r.json().then((data) => {
        if (!r.ok || (data && data.status)) throw new Error((data && (data.description || data.message)) || 'add failed');
        window.location.href = '/checkout';
      }))
      .catch(() => {
        alert(T.fail);
        ctaButtons.forEach((b) => { b.removeAttribute('disabled'); b.classList.remove('is-busy'); });
        render();
      });
  }
  ctaButtons.forEach((b) => b.addEventListener('click', buyPack));

  render();
})();
